import React, { createContext } from "react"
import Footer from './../footer/footer'
import PropTypes from 'prop-types'
import './../../styles/index.scss'
export const MobileStateContext = createContext(null)

const Layout = (props) => {
  return (
    <div>
      <div>
        {props.children}
        <Footer isMobile={props.isMobile} className="container-fluid" />
      </div>
    </div>
  )
}

export default Layout

Layout.propTypes = {
  children: PropTypes.any,
  isMobile: PropTypes.bool,
}